import React from "react";
import { Link } from "react-router-dom";
import PropertyImage from "../../images/post.png";

const ListPropertySection = () => {
  return (
    <div className="relative flex flex-col md:flex-row items-center justify-between px-6 py-16 md:py-24 bg-gradient-to-r from-emerald-50 to-green-50 overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute -top-24 -left-24 w-64 h-64 rounded-full bg-emerald-200 opacity-20"></div>
      <div className="absolute -bottom-24 -right-24 w-64 h-64 rounded-full bg-green-200 opacity-20"></div>
      
      <div className="relative z-10 bg-white p-8 md:p-10 rounded-2xl shadow-lg text-center md:text-left w-full md:w-7/12 lg:w-5/12 transform transition-all duration-300 hover:shadow-xl">
        <h1 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-emerald-600 to-green-600 bg-clip-text text-transparent">
          List Your Property Today!
        </h1>
        <p className="text-gray-700 text-lg mb-8 leading-relaxed">
          Selling or renting your property has never been easier! Create a listing in just a few
          simple steps and connect with potential buyers or tenants quickly.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <Link to="/create-listing?type=sale" className="flex-1">
            <button className="w-full inline-flex items-center justify-center bg-gradient-to-r from-emerald-500 to-green-500 text-white font-semibold py-4 px-6 text-lg rounded-xl hover:from-emerald-600 hover:to-green-600 transition-all duration-300 transform hover:-translate-y-1 shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2">
              Sell Property
            </button>
          </Link>
          <Link to="/create-listing?type=rent" className="flex-1">
            <button className="w-full inline-flex items-center justify-center bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-semibold py-4 px-6 text-lg rounded-xl hover:from-teal-600 hover:to-cyan-600 transition-all duration-300 transform hover:-translate-y-1 shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:ring-offset-2">
              Rent Property
            </button>
          </Link>
        </div>
        
        <p className="text-sm text-gray-600 mt-4">
          ✓ Free to list ✓ Reach thousands of buyers ✓ Professional presentation
        </p>
      </div>

      <div className="relative z-10 w-full md:w-2/5 mt-10 md:mt-0">
        <div className="relative">
          <img
            src={PropertyImage}
            alt="Real estate property listing"
            className="w-full rounded-2xl h-[500px] shadow-lg transform transition-all duration-500 hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/20 to-transparent rounded-2xl"></div>
        </div>
        
        {/* Decorative element */}
        <div className="hidden lg:block absolute -bottom-6 -right-6 w-24 h-24 rounded-full bg-gradient-to-r from-emerald-400 to-green-500 opacity-20"></div>
      </div>
    </div>
  );
};

export default ListPropertySection;